import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const dict = {
  it: {
    brand_sub: "Rating & Analisi del Credito",
    nav_features: "Funzionalità",
    nav_method: "Metodologia",
    nav_login: "Accedi",
    nav_dashboard: "Area di Lavoro",
    nav_logout: "Esci",
    nav_new: "Nuova Analisi",
    hero_badge: "Sistema esperto & reti neurali",
    hero_title: "Analisi di bilancio e merito creditizio, in un'unica piattaforma",
    hero_sub: "Riclassificazione automatica, flussi di cassa, quozienti e rating sintetico con commento autonomo generato dal sistema.",
    hero_cta: "Inizia l'analisi",
    hero_cta2: "Scopri il metodo",
    hv_rating: "Rating sintetico",
    hv_grade_band: "Investment Grade",
    hv_pd: "PD stimata",
    hv_liq: "Liquidità", hv_sol: "Solidità", hv_red: "Redditività", hv_cov: "Copertura",
    hv_mc: "1.500 simulazioni Monte Carlo",
    hero_trust1: "8 settori benchmark", hero_trust2: "Diagnosi < 2 min", hero_trust3: "Report PDF pronto",
    features_title: "Un motore analitico completo",
    features_sub: "Sei moduli integrati che trasformano i dati grezzi di bilancio in una valutazione del credito professionale.",
    f_ingest_t: "Acquisizione Dati",
    f_ingest_d: "Importa bilanci in CSV o PDF con parser automatico, oppure inserisci i dati manualmente.",
    f_reclass_t: "Riclassificazione di Bilancio",
    f_reclass_d: "Stato Patrimoniale finanziario e Conto Economico a valore aggiunto: VP, MOL/EBITDA, EBIT, Utile Netto.",
    f_cash_t: "Rendiconto Finanziario",
    f_cash_d: "Flussi di cassa da attività operativa, di investimento e di finanziamento.",
    f_ratios_t: "Quozienti di Bilancio",
    f_ratios_d: "Liquidità, solidità/leva, redditività ed efficienza con indicatori visivi.",
    f_rating_t: "Rating Neurale & Esperto",
    f_rating_d: "Punteggio sintetico A→D che combina dati strutturali e dati andamentali.",
    f_comment_t: "Commento Autonomo",
    f_comment_d: "Sintesi esecutiva generata automaticamente al termine dell'analisi.",
    method_title: "Fondamento scientifico",
    method_body: "Il sistema unisce tecniche di rete neurale e sistemi esperti per replicare il ragionamento dell'analista del credito, integrando i quozienti strutturali con i dati andamentali (Centrale Rischi, storia dei pagamenti, momentum operativo).",
    footer_rights: "Tutti i diritti riservati.",
    footer_related: "App collegate",
    footer_privacy: "Privacy",
    footer_terms: "Termini di Servizio",
    footer_contact: "Contatti",
    footer_legal: "Legale",
    footer_tagline: "Analisi di bilancio, rating del credito e intelligenza predittiva.",
    login_title: "Accedi alla piattaforma",
    register_title: "Crea il tuo account",
    email: "Email",
    password: "Password",
    name: "Nome",
    login_btn: "Accedi",
    register_btn: "Registrati",
    no_account: "Non hai un account?",
    have_account: "Hai già un account?",
    dash_title: "Area di Lavoro",
    dash_sub: "Le tue analisi e valutazioni del credito",
    dash_empty: "Nessuna analisi ancora. Creane una nuova per iniziare.",
    dash_new: "Nuova Analisi",
    col_company: "Impresa",
    col_year: "Esercizio",
    col_grade: "Rating",
    col_score: "Punteggio",
    col_date: "Data",
    col_actions: "Azioni",
    view: "Apri",
    delete: "Elimina",
    new_title: "Nuova Analisi di Bilancio",
    company: "Ragione sociale",
    fiscal_year: "Anno di esercizio",
    sector: "Settore (per benchmark)",
    language_report: "Lingua del report",
    tab_manual: "Inserimento Manuale",
    tab_upload: "Importa File",
    upload_hint: "Carica un bilancio in CSV o PDF. Il sistema estrarrà automaticamente le voci riconosciute.",
    upload_btn: "Seleziona file (CSV / PDF)",
    upload_done: "voci riconosciute e precompilate.",
    section_current: "Esercizio Corrente",
    section_prior: "Esercizio Precedente (opzionale, per flussi e trend)",
    section_prior_years: "Anni precedenti (trend storico)",
    prior_years_hint: "Aggiungi i bilanci degli esercizi precedenti (max 4) per abilitare i grafici di trend pluriennale.",
    add_year: "Aggiungi anno precedente",
    remove_year: "Rimuovi",
    year_label: "Anno",
    r_trend: "Andamento Pluriennale",
    trend_sub: "Evoluzione delle grandezze chiave sugli esercizi analizzati.",
    trend_revenue: "Ricavi · EBITDA · Utile",
    trend_equity: "Patrimonio netto e PFN",
    trend_score: "Score sintetico per anno",
    trend_note: "Nota: lo score per anno utilizza gli attuali dati andamentali come approssimazione indicativa.",
    trend_indices: "Indici chiave per anno",
    section_assets: "Attivo",
    section_liab: "Patrimonio Netto e Passivo",
    section_income: "Conto Economico",
    section_behavioral: "Dati Andamentali",
    beh_cr: "Trend Centrale Rischi",
    beh_pay: "Ritardi nei pagamenti",
    beh_fidi: "Utilizzo fidi (%)",
    beh_sconf: "Sconfinamenti",
    beh_anni: "Anni di attività",
    opt_improve: "Miglioramento",
    opt_stable: "Stabile",
    opt_worsen: "Peggioramento",
    opt_none: "Nessuno",
    opt_occ: "Occasionali",
    opt_freq: "Frequenti",
    yes: "Sì",
    no: "No",
    analyze_btn: "Genera Analisi & Rating",
    analyzing: "Elaborazione in corso…",
    report_title: "Report di Analisi",
    r_reclass: "Riclassificazione",
    r_sp: "Stato Patrimoniale",
    r_ce: "Conto Economico",
    r_cash: "Rendiconto Finanziario",
    r_ratios: "Quozienti di Bilancio",
    r_rating: "Rating Sintetico",
    r_comment: "Commento Autonomo di Fine Analisi",
    r_summary: "Sintesi Esecutiva",
    r_strengths: "Punti di Forza",
    r_weaknesses: "Criticità",
    r_drivers: "Driver di Rischio",
    r_rationale: "Motivazione del Rating",
    r_reco: "Raccomandazioni",
    print: "Stampa / PDF",
    regenerate: "Rigenera commento",
    back: "Indietro",
    ai_generated: "Generato dall'AI",
    commentary_generating: "Commento in generazione…",
    commentary_generating_sub: "Il sistema sta redigendo la sintesi esecutiva. L'operazione richiede alcuni secondi.",
    commentary_error: "Generazione del commento non riuscita. Riprova con il pulsante \"Rigenera commento\".",
    r_diagnosis: "Diagnosi Esecutiva",
    r_causal: "Mappa Causale dei Driver",
    r_early: "Indicatori di Early Warning",
    r_ops90: "Decisioni Operative · 90 giorni",
    r_strat12: "Decisioni Strategiche · 12 mesi",
    ew_ok: "OK", ew_watch: "Attenzione", ew_alert: "Allerta",
    sim_title: "Simulazioni & Stress Test",
    sim_sub: "Modello predittivo: scenari, what-if e probabilità di crisi (Monte Carlo).",
    sim_scenarios: "Scenari di Stress",
    sim_whatif: "What-If Personalizzato",
    sim_montecarlo: "Analisi Monte Carlo",
    sim_mc_sub: "Distribuzione su 1.500 simulazioni con shock casuali su ricavi, costi, tassi e incassi.",
    sim_revenue: "Variazione Ricavi", sim_cost: "Variazione Costi",
    sim_rate: "Shock Tassi", sim_dso: "Δ Giorni Crediti (DSO)",
    sim_calc: "Calcola impatto", sim_calculating: "Calcolo…",
    sim_impact: "Impatto sullo scenario personalizzato",
    mc_neg_income: "Prob. perdita d'esercizio",
    mc_liq: "Prob. crisi di liquidità",
    mc_downgrade: "Prob. downgrade (fascia C/D)",
    mc_cov: "Prob. copertura oneri < 1x",
    mc_score_range: "Score atteso (P5 · mediana · P95)",
    m_ricavi: "Ricavi", m_ebitda: "EBITDA", m_ebit: "EBIT", m_utile: "Utile Netto", m_pfn: "PFN", m_score: "Score",
    ratio_na: "n/d", ratio_na_note: "Non applicabile",
    inactive_title: "Impresa inattiva o senza ricavi",
    inactive_body: "In assenza di ricavi alcuni indicatori (rotazione dell'attivo, giorni di incasso e di magazzino) non sono matematicamente calcolabili. Questo riflette lo stato operativo dell'impresa e non rappresenta un errore tecnico.",
    r_bench: "Benchmark di Settore",
    bench_sub: "Confronto dei principali indici con la media del settore.",
    bench_indicative: "Medie di settore indicative, a solo scopo comparativo.",
    bench_company: "Azienda", bench_sector: "Media settore",
    bench_score_vs: "Score sintetico vs media di settore",
    bench_above: "Sopra la media", bench_inline: "In linea", bench_below: "Sotto la media",
    bench_ateco: "Codice ATECO", bench_none: "Seleziona un settore in fase di analisi per abilitare il confronto.",
    pdf: "Scarica PDF", pdf_generating: "Generazione PDF…",
    pdf_wait_ai: "Il commento AI è ancora in generazione: attendi il completamento per includerlo nel PDF.",
    upload_summary_title: "Riepilogo caricamento",
    upload_recognized: "Voci riconosciute", upload_missing: "Voci non valorizzate",
    upload_review_hint: "Verifica i valori estratti e completa le voci mancanti prima di generare l'analisi.",
    bp_nav: "Business Plan", bp_new: "Nuovo Business Plan",
    bp_tab_analyses: "Analisi Bilancio", bp_tab_bp: "Business Plan",
    sector_placeholder: "Seleziona settore",
    chart_margins: "Cascata dei Margini", chart_structure: "Struttura Patrimoniale",
    chart_assets: "Impieghi", chart_sources: "Fonti",
    chart_fixed: "Attivo fisso", chart_current_a: "Attivo corrente",
    chart_equity: "Patrimonio netto", chart_consol: "Passivo consolidato", chart_current_l: "Passivo corrente",
    chart_scenario_score: "Score per Scenario",
    nav_pricing: "Prezzi",
    mk_intro_eye: "La differenza Rexxpons",
    mk_intro_title: "Oltre la semplice contabilità, verso l'intelligenza predittiva",
    mk_intro_body: "Rexxpons non si limita a leggere il passato: trasforma i dati di bilancio in un modello vivo che anticipa i rischi, spiega le cause e guida le decisioni di credito.",
    mk_s1: "Diagnosi causale, non solo descrittiva: dai margini alla cassa al rating.",
    mk_s2: "Motore predittivo con stress test, scenari e simulazioni Monte Carlo.",
    mk_s3: "Rating sintetico che unisce dati strutturali e dati andamentali.",
    mk_s4: "Commento autonomo e decisioni operative pronte all'uso.",
    mk_tech_title: "Tecnologia · Come Funziona",
    mk_tech_sub: "Dal dato grezzo alla decisione, in tre passaggi.",
    mk_tech_1_t: "1 · Acquisizione & Riclassificazione",
    mk_tech_1_d: "Carica il bilancio (CSV/PDF) o inserisci i dati: il sistema riclassifica Stato Patrimoniale e Conto Economico e calcola i margini chiave.",
    mk_tech_2_t: "2 · Analisi & Rating Neurale",
    mk_tech_2_d: "Quozienti, flussi di cassa e un motore esperto/neurale producono un rating sintetico con indicatori di early-warning.",
    mk_tech_3_t: "3 · Predizione & Decisioni",
    mk_tech_3_d: "Stress test, scenari e Monte Carlo simulano il futuro; il sistema genera commento autonomo e leve operative a 90 giorni.",
    mk_adv_title: "Vantaggi per Risk Manager e Aziende",
    adv_eye: "Perché scegliere Rexxpons",
    adv_head: "Il vantaggio competitivo di una diagnosi predittiva",
    adv_sub: "Non un semplice foglio di indici: un motore che diagnostica, simula il futuro e trasforma i numeri in decisioni.",
    adv_speed_stat: "< 2 min",
    adv_speed_t: "Diagnosi automatica",
    adv_speed_d: "Da bilancio a rating, cash flow e commento esecutivo in pochi minuti, senza intervento manuale.",
    adv_mc_stat: "1.500",
    adv_mc_t: "Simulazioni Monte Carlo",
    adv_mc_d: "Stress test e scenari probabilistici stimano perdita attesa, crisi di liquidità e downgrade del rating.",
    adv_reco_stat: "90gg · 12 mesi",
    adv_reco_t: "Raccomandazioni azionabili",
    adv_reco_d: "Leve operative a 90 giorni e strategiche a 12 mesi, pronte all'uso per analisti e imprenditori.",
    mk_adv_1_t: "Decisioni più rapide", mk_adv_1_d: "Un rating e una diagnosi in pochi minuti, non giorni.",
    mk_adv_2_t: "Rischio sotto controllo", mk_adv_2_d: "Early-warning e probabilità di default per anticipare le crisi.",
    mk_adv_3_t: "Linguaggio del business", mk_adv_3_d: "Report chiari e azionabili per analisti e imprenditori.",
    mk_adv_4_t: "Predittivo, non statico", mk_adv_4_d: "Simulazioni what-if per rispondere a «cosa succede se…».",
    mk_circ_title: "Consulenza e Soluzioni sul Circolante",
    mk_circ_body: "Ottimizziamo il capitale circolante: analisi del ciclo di incasso e pagamento, liberazione di cassa a breve termine e strategie di finanziamento su misura per la tua impresa.",
    mk_circ_cta: "Richiedi una consulenza",
    pr_title: "Piani e Prezzi",
    pr_sub: "Scegli come pagare: singolo report, pacchetto o abbonamento. Nessun accesso gratuito.",
    pr_month: "/mese", pr_popular: "Più scelto",
    pr_cta_sub: "Attiva piano", pr_cta_buy: "Acquista pacchetto", pr_loading: "Reindirizzamento…",
    pr_free_left: "analisi gratuite rimaste",
    pr_single_name: "Singolo Report", pr_single_price: "€15", pr_single_cta: "Acquista report",
    pr_single_f1: "1 analisi completa con rating",
    pr_single_f2: "Download del report in PDF",
    pr_single_f3: "Nessun abbonamento · una tantum",
    ent_no_plan: "Nessun piano",
    pr_starter_f1: "Analisi illimitate", pr_starter_f2: "Rating & report completi", pr_starter_f3: "Stress test & scenari",
    pr_pro_f1: "Tutto di Starter", pr_pro_f2: "Monte Carlo avanzato", pr_pro_f3: "Commento AI prioritario", pr_pro_f4: "Supporto dedicato",
    pr_credit_f1: "10 analisi complete", pr_credit_f2: "Nessun abbonamento", pr_credit_f3: "Crediti senza scadenza",
    pr_credit_name: "Pacchetto 10 Report", pr_credit_price: "€199",
    pay_processing: "Verifica del pagamento in corso…",
    pay_success_title: "Pagamento completato!", pay_success_body: "Il tuo piano è attivo. Ora puoi generare analisi.",
    pay_cancel_title: "Pagamento annullato", pay_cancel_body: "Nessun addebito effettuato. Puoi riprovare quando vuoi.",
    pay_go: "Vai all'area di lavoro", pay_pricing: "Torna ai piani",
    ent_free_badge: "gratis", ent_credits_badge: "crediti",
    cat_liquidity: "Liquidità",
    cat_leverage: "Solidità & Leva",
    cat_profitability: "Redditività",
    cat_efficiency: "Efficienza",
    score_label: "Punteggio",
    pd_label: "PD stimata",
    bl_eye: "Modulo integrato",
    bl_title: "Dal rating al Business Plan predittivo",
    bl_body: "Trasforma l'analisi storica in un piano prospettico: proiezioni pluriennali, NPV, IRR e break-even, scenari What-If e un piano narrativo generato dall'AI — tutto nella stessa piattaforma.",
    bl_f1: "NPV, IRR e break-even calcolati automaticamente",
    bl_f2: "Scenari What-If: base, ottimistico, pessimistico",
    bl_f3: "Piano narrativo AI: mercato, strategia, rischi",
    bl_f4: "Collega il business plan all'analisi di bilancio",
    bl_cta: "Crea un Business Plan",
    bl_proj: "Proiezioni a 5 anni",
    bl_kpi_npv: "NPV (VAN)",
    bl_kpi_irr: "IRR (TIR)",
    bl_kpi_be: "Break-even",
    bl_rev: "Ricavi", bl_fcf: "FCF cumulato",
    mv_report: "Report di Analisi",
    mv_trend: "Ricavi · EBITDA · Utile",
  },
  en: {
    brand_sub: "Credit Rating & Analytics",
    nav_features: "Features",
    nav_method: "Methodology",
    nav_login: "Sign in",
    nav_dashboard: "Workspace",
    nav_logout: "Sign out",
    nav_new: "New Analysis",
    hero_badge: "Expert system & neural networks",
    hero_title: "Financial statement analysis and credit rating, in one platform",
    hero_sub: "Automatic reclassification, cash flows, ratios and synthetic rating with an autonomous system-generated commentary.",
    hero_cta: "Start analysis",
    hero_cta2: "See the method",
    hv_rating: "Synthetic rating",
    hv_grade_band: "Investment Grade",
    hv_pd: "Estimated PD",
    hv_liq: "Liquidity", hv_sol: "Solidity", hv_red: "Profitability", hv_cov: "Coverage",
    hv_mc: "1,500 Monte Carlo simulations",
    hero_trust1: "8 benchmark sectors", hero_trust2: "Diagnosis < 2 min", hero_trust3: "PDF report ready",
    features_title: "A complete analytical engine",
    features_sub: "Six integrated modules turning raw financial data into a professional credit assessment.",
    f_ingest_t: "Data Ingestion",
    f_ingest_d: "Import statements in CSV or PDF with an automatic parser, or enter data manually.",
    f_reclass_t: "Statement Reclassification",
    f_reclass_d: "Financial balance sheet and value-added income statement: Production Value, EBITDA, EBIT, Net Income.",
    f_cash_t: "Cash Flow Statement",
    f_cash_d: "Cash flows from operating, investing and financing activities.",
    f_ratios_t: "Financial Ratios",
    f_ratios_d: "Liquidity, solvency/leverage, profitability and efficiency with visual indicators.",
    f_rating_t: "Neural & Expert Rating",
    f_rating_d: "Synthetic A→D score combining structural and behavioral data.",
    f_comment_t: "Autonomous Commentary",
    f_comment_d: "Executive synthesis generated automatically at the end of the analysis.",
    method_title: "Scientific foundation",
    method_body: "The system blends neural network techniques and expert systems to replicate the credit analyst's reasoning, integrating structural ratios with behavioral data (Central Risks, payment history, operational momentum).",
    footer_rights: "All rights reserved.",
    footer_related: "Related apps",
    footer_privacy: "Privacy",
    footer_terms: "Terms of Service",
    footer_contact: "Contact",
    footer_legal: "Legal",
    footer_tagline: "Financial statement analysis, credit rating and predictive intelligence.",
    login_title: "Sign in to the platform",
    register_title: "Create your account",
    email: "Email",
    password: "Password",
    name: "Name",
    login_btn: "Sign in",
    register_btn: "Sign up",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    dash_title: "Workspace",
    dash_sub: "Your analyses and credit assessments",
    dash_empty: "No analyses yet. Create a new one to get started.",
    dash_new: "New Analysis",
    col_company: "Company",
    col_year: "Year",
    col_grade: "Rating",
    col_score: "Score",
    col_date: "Date",
    col_actions: "Actions",
    view: "Open",
    delete: "Delete",
    new_title: "New Financial Analysis",
    company: "Company name",
    fiscal_year: "Fiscal year",
    sector: "Sector (for benchmark)",
    language_report: "Report language",
    tab_manual: "Manual Input",
    tab_upload: "Import File",
    upload_hint: "Upload a statement in CSV or PDF. The system will automatically extract recognized items.",
    upload_btn: "Select file (CSV / PDF)",
    upload_done: "items recognized and pre-filled.",
    section_current: "Current Period",
    section_prior: "Prior Period (optional, for cash flows & trends)",
    section_prior_years: "Prior years (historical trend)",
    prior_years_hint: "Add prior-year statements (max 4) to enable multi-year trend charts.",
    add_year: "Add prior year",
    remove_year: "Remove",
    year_label: "Year",
    r_trend: "Multi-Year Trend",
    trend_sub: "Evolution of key figures across the analyzed periods.",
    trend_revenue: "Revenue · EBITDA · Net Income",
    trend_equity: "Equity and Net Financial Position",
    trend_score: "Synthetic score by year",
    trend_note: "Note: the per-year score uses the current behavioral data as an indicative approximation.",
    trend_indices: "Key ratios by year",
    section_assets: "Assets",
    section_liab: "Equity and Liabilities",
    section_income: "Income Statement",
    section_behavioral: "Behavioral Data",
    beh_cr: "Central Risks trend",
    beh_pay: "Payment delays",
    beh_fidi: "Credit line utilization (%)",
    beh_sconf: "Overdrafts",
    beh_anni: "Years in business",
    opt_improve: "Improving",
    opt_stable: "Stable",
    opt_worsen: "Worsening",
    opt_none: "None",
    opt_occ: "Occasional",
    opt_freq: "Frequent",
    yes: "Yes",
    no: "No",
    analyze_btn: "Generate Analysis & Rating",
    analyzing: "Processing…",
    report_title: "Analysis Report",
    r_reclass: "Reclassification",
    r_sp: "Balance Sheet",
    r_ce: "Income Statement",
    r_cash: "Cash Flow Statement",
    r_ratios: "Financial Ratios",
    r_rating: "Synthetic Rating",
    r_comment: "Autonomous End-of-Analysis Commentary",
    r_summary: "Executive Summary",
    r_strengths: "Strengths",
    r_weaknesses: "Weaknesses",
    r_drivers: "Risk Drivers",
    r_rationale: "Rating Rationale",
    r_reco: "Recommendations",
    print: "Print / PDF",
    regenerate: "Regenerate commentary",
    back: "Back",
    ai_generated: "AI generated",
    commentary_generating: "Generating commentary…",
    commentary_generating_sub: "The system is drafting the executive synthesis. This takes a few seconds.",
    commentary_error: "Commentary generation failed. Retry using the \"Regenerate commentary\" button.",
    r_diagnosis: "Executive Diagnosis",
    r_causal: "Causal Driver Map",
    r_early: "Early Warning Indicators",
    r_ops90: "Operational Decisions · 90 days",
    r_strat12: "Strategic Decisions · 12 months",
    ew_ok: "OK", ew_watch: "Watch", ew_alert: "Alert",
    sim_title: "Simulation & Stress Test",
    sim_sub: "Predictive model: scenarios, what-if and crisis probability (Monte Carlo).",
    sim_scenarios: "Stress Scenarios",
    sim_whatif: "Custom What-If",
    sim_montecarlo: "Monte Carlo Analysis",
    sim_mc_sub: "Distribution over 1,500 simulations with random shocks on revenue, costs, rates and collections.",
    sim_revenue: "Revenue change", sim_cost: "Cost change",
    sim_rate: "Rate shock", sim_dso: "Δ DSO (days)",
    sim_calc: "Compute impact", sim_calculating: "Computing…",
    sim_impact: "Impact of the custom scenario",
    mc_neg_income: "Prob. of net loss",
    mc_liq: "Prob. of liquidity crisis",
    mc_downgrade: "Prob. of downgrade (band C/D)",
    mc_cov: "Prob. interest coverage < 1x",
    mc_score_range: "Expected score (P5 · median · P95)",
    m_ricavi: "Revenue", m_ebitda: "EBITDA", m_ebit: "EBIT", m_utile: "Net Income", m_pfn: "NFP", m_score: "Score",
    ratio_na: "n/a", ratio_na_note: "Not applicable",
    inactive_title: "Inactive company or no revenue",
    inactive_body: "Without revenue, some indicators (asset turnover, collection and inventory days) are not mathematically computable. This reflects the company's operating status and is not a technical error.",
    r_bench: "Sector Benchmark",
    bench_sub: "Comparison of key ratios against the sector average.",
    bench_indicative: "Indicative sector averages, for comparison purposes only.",
    bench_company: "Company", bench_sector: "Sector average",
    bench_score_vs: "Synthetic score vs sector average",
    bench_above: "Above average", bench_inline: "In line", bench_below: "Below average",
    bench_ateco: "ATECO code", bench_none: "Select a sector during analysis to enable the comparison.",
    pdf: "Download PDF", pdf_generating: "Generating PDF…",
    pdf_wait_ai: "AI commentary is still generating: wait for completion to include it in the PDF.",
    upload_summary_title: "Upload summary",
    upload_recognized: "Recognized items", upload_missing: "Empty items",
    upload_review_hint: "Review the extracted values and complete the missing items before generating the analysis.",
    bp_nav: "Business Plan", bp_new: "New Business Plan",
    bp_tab_analyses: "Balance Sheet Analyses", bp_tab_bp: "Business Plan",
    sector_placeholder: "Select sector",
    chart_margins: "Margins Ladder", chart_structure: "Balance Sheet Structure",
    chart_assets: "Assets", chart_sources: "Sources",
    chart_fixed: "Fixed assets", chart_current_a: "Current assets",
    chart_equity: "Equity", chart_consol: "Long-term liab.", chart_current_l: "Current liab.",
    chart_scenario_score: "Score by Scenario",
    nav_pricing: "Pricing",
    mk_intro_eye: "The Rexxpons difference",
    mk_intro_title: "Beyond mere accounting, towards predictive intelligence",
    mk_intro_body: "Rexxpons doesn't just read the past: it turns financial statements into a living model that anticipates risk, explains causes and drives credit decisions.",
    mk_s1: "Causal diagnosis, not just description: from margins to cash to rating.",
    mk_s2: "Predictive engine with stress tests, scenarios and Monte Carlo simulations.",
    mk_s3: "Synthetic rating combining structural and behavioral data.",
    mk_s4: "Autonomous commentary and ready-to-use operational decisions.",
    mk_tech_title: "Technology · How It Works",
    mk_tech_sub: "From raw data to decision, in three steps.",
    mk_tech_1_t: "1 · Ingestion & Reclassification",
    mk_tech_1_d: "Upload the statement (CSV/PDF) or enter data: the system reclassifies the balance sheet and income statement and computes key margins.",
    mk_tech_2_t: "2 · Analysis & Neural Rating",
    mk_tech_2_d: "Ratios, cash flows and an expert/neural engine produce a synthetic rating with early-warning indicators.",
    mk_tech_3_t: "3 · Prediction & Decisions",
    mk_tech_3_d: "Stress tests, scenarios and Monte Carlo simulate the future; the system generates autonomous commentary and 90-day operational levers.",
    mk_adv_title: "Benefits for Risk Managers and Companies",
    adv_eye: "Why choose Rexxpons",
    adv_head: "The competitive edge of a predictive diagnosis",
    adv_sub: "Not just a ratio sheet: an engine that diagnoses, simulates the future and turns numbers into decisions.",
    adv_speed_stat: "< 2 min",
    adv_speed_t: "Automated diagnosis",
    adv_speed_d: "From statement to rating, cash flow and executive commentary in minutes, with no manual work.",
    adv_mc_stat: "1,500",
    adv_mc_t: "Monte Carlo simulations",
    adv_mc_d: "Stress tests and probabilistic scenarios estimate expected loss, liquidity crises and rating downgrades.",
    adv_reco_stat: "90d · 12mo",
    adv_reco_t: "Actionable recommendations",
    adv_reco_d: "90-day operational and 12-month strategic levers, ready to use for analysts and entrepreneurs.",
    mk_adv_1_t: "Faster decisions", mk_adv_1_d: "A rating and diagnosis in minutes, not days.",
    mk_adv_2_t: "Risk under control", mk_adv_2_d: "Early-warnings and default probability to anticipate crises.",
    mk_adv_3_t: "Business language", mk_adv_3_d: "Clear, actionable reports for analysts and entrepreneurs.",
    mk_adv_4_t: "Predictive, not static", mk_adv_4_d: "What-if simulations answering “what happens if…”.",
    mk_circ_title: "Working Capital Advisory & Solutions",
    mk_circ_body: "We optimize working capital: collection and payment cycle analysis, short-term cash release and tailored financing strategies for your business.",
    mk_circ_cta: "Request a consultation",
    pr_title: "Plans & Pricing",
    pr_sub: "Choose how to pay: single report, pack or subscription. No free access.",
    pr_month: "/mo", pr_popular: "Most popular",
    pr_cta_sub: "Subscribe", pr_cta_buy: "Buy pack", pr_loading: "Redirecting…",
    pr_free_left: "free analyses left",
    pr_single_name: "Single Report", pr_single_price: "€15", pr_single_cta: "Buy report",
    pr_single_f1: "1 full analysis with rating",
    pr_single_f2: "PDF report download",
    pr_single_f3: "No subscription · one-time",
    ent_no_plan: "No plan",
    pr_starter_f1: "Unlimited analyses", pr_starter_f2: "Full rating & reports", pr_starter_f3: "Stress test & scenarios",
    pr_pro_f1: "Everything in Starter", pr_pro_f2: "Advanced Monte Carlo", pr_pro_f3: "Priority AI commentary", pr_pro_f4: "Dedicated support",
    pr_credit_f1: "10 full analyses", pr_credit_f2: "No subscription", pr_credit_f3: "Credits never expire",
    pr_credit_name: "10 Report Pack", pr_credit_price: "€199",
    pay_processing: "Verifying payment…",
    pay_success_title: "Payment complete!", pay_success_body: "Your plan is active. You can now generate analyses.",
    pay_cancel_title: "Payment cancelled", pay_cancel_body: "No charge was made. You can try again anytime.",
    pay_go: "Go to workspace", pay_pricing: "Back to plans",
    ent_free_badge: "free", ent_credits_badge: "credits",
    cat_liquidity: "Liquidity",
    cat_leverage: "Solvency & Leverage",
    cat_profitability: "Profitability",
    cat_efficiency: "Efficiency",
    score_label: "Score",
    pd_label: "Est. PD",
    bl_eye: "Integrated module",
    bl_title: "From rating to a predictive Business Plan",
    bl_body: "Turn historical analysis into a forward-looking plan: multi-year projections, NPV, IRR and break-even, What-If scenarios and an AI-generated narrative plan — all in the same platform.",
    bl_f1: "NPV, IRR and break-even computed automatically",
    bl_f2: "What-If scenarios: base, optimistic, pessimistic",
    bl_f3: "AI narrative plan: market, strategy, risks",
    bl_f4: "Link the business plan to the balance-sheet analysis",
    bl_cta: "Create a Business Plan",
    bl_proj: "5-year projections",
    bl_kpi_npv: "NPV",
    bl_kpi_irr: "IRR",
    bl_kpi_be: "Break-even",
    bl_rev: "Revenue", bl_fcf: "Cumulative FCF",
    mv_report: "Analysis Report",
    mv_trend: "Revenue · EBITDA · Net Income",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("mmr_lang") || "it");
  const change = useCallback((l) => {
    setLang(l);
    localStorage.setItem("mmr_lang", l);
  }, []);
  const t = useCallback((key) => dict[lang][key] ?? dict.it[key] ?? key, [lang]);
  const value = useMemo(() => ({ lang, setLang: change, t }), [lang, change, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
